module.exports = __webpack_public_path__ + "static/Case-Studies-Blitz-4c4b8f03aece31f226d19021614ec7ae.jpeg";